/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexDto } from '../../models/backend-opex-dto';

export interface SalesOpexsList$Params {
  /**
   * * `3` - Не облагается
   * * `1` - Экспортная ставка
   * * `2` - Льготная ставка
   * * `0` - Основная ставка
   * * `4` - Ставка продаж физ. лицам
   * * `5` - Ставка продаж юр. лицам
   */
  VAT_rate?: 0 | 1 | 2 | 3 | 4 | 5;

  /**
   * * `0` - Материальные затраты
   * * `1` - Товары
   * * `2` - Заработная плата
   * * `3` - Социальное обеспечение и социальные налоги
   * * `4` - Амортизация
   * * `5` - Прочие производственные расходы
   * * `6` - Арендные расходы
   * * `7` - Налоговые расходы
   * * `8` - Коммерческие расходы
   * * `9` - Управленческие расходы
   * * `10` - Прочие расходы
   */
  cost_types_by_economic_grouping?: 0 | 1 | 10 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  create_date?: string;
  end_date?: string;
  group?: number;
  is_blocked?: boolean;
  name?: string;
  one_time_opex?: boolean;
  opex_date?: string;
  price?: number;
  price_indexation?: boolean;
  product_id?: number;

  /**
   * * `0` - Стандартный
   * * `1` - Расширенный
   */
  product_type?: (0 | 1) | null;
  production_volume?: number;
  quantity_opexs?: number;
  start_date?: string;
  tax?: boolean;
  type_tax?: boolean;

  /**
   * * `0` - Постоянные расходы
   * * `1` - Переменные расходы
   */
  types_business_activity_costs?: 0 | 1;

  /**
   * * `0` - шт.
   * * `1` - компл.
   * * `2` - ящ.
   * * `3` - тн.
   * * `4` - ед.
   * * `5` - м3
   * * `6` - Баррель
   * * `7` - МВт
   * * `8` - Гкал
   * * `9` - усл.
   */
  unit?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  variant?: number;
}

export function salesOpexsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesOpexsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOpexDto>>> {
  const rb = new RequestBuilder(rootUrl, salesOpexsList.PATH, 'get');
  if (params) {
    rb.query('VAT_rate', params.VAT_rate, {});
    rb.query('cost_types_by_economic_grouping', params.cost_types_by_economic_grouping, {});
    rb.query('create_date', params.create_date, {});
    rb.query('end_date', params.end_date, {});
    rb.query('group', params.group, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('name', params.name, {});
    rb.query('one_time_opex', params.one_time_opex, {});
    rb.query('opex_date', params.opex_date, {});
    rb.query('price', params.price, {});
    rb.query('price_indexation', params.price_indexation, {});
    rb.query('product_id', params.product_id, {});
    rb.query('product_type', params.product_type, {});
    rb.query('production_volume', params.production_volume, {});
    rb.query('quantity_opexs', params.quantity_opexs, {});
    rb.query('start_date', params.start_date, {});
    rb.query('tax', params.tax, {});
    rb.query('type_tax', params.type_tax, {});
    rb.query('types_business_activity_costs', params.types_business_activity_costs, {});
    rb.query('unit', params.unit, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOpexDto>>;
    }),
  );
}

salesOpexsList.PATH = '/api/sales/opexs/';
